import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface HyperliquidSmartMoneyMetrics {
  totalTraders: number;
  activeTraders: number;
  longTraders: number;
  shortTraders: number;
  netPositionBias: number;
  totalExposureUsd: number;
  netFlow7d: number;
  avgLeverage: number;
  timestamp: number;
}

export interface HyperliquidData {
  asset: string;
  source: string;
  smartMoneyMetrics: HyperliquidSmartMoneyMetrics;
  cached_at: string;
}

export const useHyperliquidData = (asset: 'BTC' | 'ETH') => {
  return useQuery({
    queryKey: ['hyperliquid-smart-money', asset],
    queryFn: async (): Promise<HyperliquidData | null> => {
      const { data, error } = await supabase
        .from('alpha_onchain_cache')
        .select('data, updated_at')
        .eq('id', `hyperliquid_smart_money_${asset}`)
        .maybeSingle();
      
      if (error || !data || !data.data) {
        return null;
      }
      
      return data.data as unknown as HyperliquidData;
    },
    refetchInterval: 10 * 60000, // 10 minutes
    staleTime: 5 * 60000, // 5 minutes
  });
};
